import { createContext } from 'react';

const InfluencerManagerContext = createContext();

export default InfluencerManagerContext;
